import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from "vue";
import { ITask } from "@/api/types/tasks";
import { getTasks, getTasksBff } from "@/api/tasks";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgPlus from "@/assets/icons/plus.svg";
import SvgEye from "@/assets/icons/eye.svg";
import SvgEyeOff from "@/assets/icons/eye-off.svg";
import { useWindowResize } from "@/utils/useWindowSize";
import TaskStatus from "@/components_v3/tasks/TaskStatus.vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import TaskDeleteTooltip from "@/components_v3/tasks/TaskDeleteTooltip.vue";
import { useMyTasks } from "@/services/TablePage/tasks";
import { FormattedItem } from "@/utils/CellsFactory";
import { useRouter } from "vue-router/composables";
import CreateTaskModal from "@/components_v3/tasks/CreateTaskModal.vue";
import TaskMobileCard from "@/components_v3/tasks/TaskMobileCard.vue";
import store from "@/store";
import { USER_ROLES } from "@/mappings/user-roles";
import { showServerError } from "@/utils";

interface Props {
    target: 'affiliate' | 'offer';
    targetId: number;
    managerId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskOnTargetDetail',
  props: {
    target: null,
    targetId: null,
    managerId: null
  },
  setup(__props: any) {

const props = __props as {
    target: 'affiliate' | 'offer';
    targetId: number;
    managerId: number;
}



const router = useRouter();

const { width } = useWindowResize();
const isMobile = computed(() => width.value <= 1264);
const isSmallButton = computed(() => width.value <= 1366);

const { headersForTargetDetail, columnsForTargetDetail } = useMyTasks();

const tasks = ref<ITask[]>([]);
const items = ref<FormattedItem<ITask>[]>([]);
const total = ref(0);
const offset = ref(0);
const isOnlyActiveTasks = ref(false);

const changePage = (offsetValue: number) => {
    offset.value = offsetValue;
    getTasksList();
};

onBeforeMount(() => {
    getTasksList();
});

const getParams = () => {
    const params = {
        target: props.target,
        target_id: props.targetId,
        status: ['to_do', 'expired', 'done'],
        offset: offset.value,
        limit: 5,
    };

    const user = store.getters['authModule/GET_USER'];
    const isNotAdmin = !user.roles.includes(USER_ROLES.ADMIN);
    if (isNotAdmin) {
        params.created_by = [user.account_id];
        params.assegnee = [user.account_id];
    }
    if (!isMobile.value) {
        params.columns = columnsForTargetDetail;
    }

    return params;
};

const getTasksList = async () => {
    try {
        const params = getParams();
        const apiMethod = isMobile.value ? getTasks : getTasksBff;
        const { data, meta } = await apiMethod(params);
        total.value = meta?.total;
        tasks.value = data;
        if (isMobile.value) return;
        items.value = data;
    } catch (err) {
        showServerError(err, 'Список задач не загружен');
    } finally {
        isShowCreateTaskModal.value = false;
    }
};

const redirectToTasks = () => {
    const query = { target: props.target, target_id: props.targetId };
    router.push({ name: 'tasks', query });
};

const getItems = computed(() => {
    if (isOnlyActiveTasks.value) {
        return items.value.filter((item) => item.status.componentData.value !== 'done');
    }
    return items.value;
});

// --Create task
const isShowCreateTaskModal = ref(false);

const openCreateTaskModal = () => {
    isShowCreateTaskModal.value = true;
};

// -- mobile list
const isShowAllTasks = ref(false);

const isShowAllTasksButton = computed(() => !isShowAllTasks.value && tasks.value.length > 5);

const getTasksForMobile = computed(() => {
    const items = isOnlyActiveTasks.value
        ? tasks.value.filter((item) => item.status !== 'done')
        : tasks.value;
    if (isShowAllTasks.value) return items;
    return items.slice(0, 5);
});

const showAllTasks = () => {
    isShowAllTasks.value = true;
};


return { __sfc: true,props, router, width, isMobile, isSmallButton, headersForTargetDetail, columnsForTargetDetail, tasks, items, total, offset, isOnlyActiveTasks, changePage, getParams, getTasksList, redirectToTasks, getItems, isShowCreateTaskModal, openCreateTaskModal, isShowAllTasks, isShowAllTasksButton, getTasksForMobile, showAllTasks, BaseButtonV2, SvgPlus, SvgEye, SvgEyeOff, TaskStatus, BaseTable, TaskDeleteTooltip, CreateTaskModal, TaskMobileCard }
}

})